import { State as CalendarState } from '../reducers/calendar-reducer';
import { Selector } from '@ngrx/store';
export const getMessage: Selector<CalendarState, string | null> = (state: CalendarState) => state.message;
export const getHasError: Selector<CalendarState, boolean> = (state: CalendarState) => state.hasError;
export const getHasSuccess: Selector<CalendarState, boolean> = (state: CalendarState) => state.hasSuccess;
export const getIsLoading: Selector<CalendarState, boolean> = (state: CalendarState) => state.isLoading;
export const getIsActive: Selector<CalendarState, boolean> = (state: CalendarState) => state.isActive;
